export const referenceTypeMap = {
    member: '2', // 會員
    visitor: '3', // 訪客
    employee: '4', // 教練
};
